// Storefront configuration returned by GET /api/configuration.
export interface AppConfiguration {
  /** Display name of the event currency, e.g. "Shopping Dollars". */
  rewardName: string;
}
